import Splide from '@splidejs/splide';

// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Showcase
     */

    const splideSliders = document.querySelectorAll('.splide');

    splideSliders.forEach(function(splideSlider) {

        const splideSliderSlides = parseInt(splideSlider.dataset.slides) || 1;
        const splideSliderType = splideSlider.dataset.slider;

        let slider;

        if (splideSliderType == "home-blog-posts") {

            slider = new Splide(splideSlider, {
                type: 'loop',
                rewind: true,
                gap: '32px',
                perPage: 3.5,
                perMove: 3,
                drag: 'free',
                snap: true,
                mediaQuery: 'max',
                autoplay: false,
                interval: 4000,
                speed: 2000,
                pauseOnHover: true,
                pagination: true,
                arrowPath: 'M3.1,35.6c0,1.6.9,3,2.3,3.8.7.4,1.5.6,2.3.6.7,0,1.4-.2,2.1-.5,10.2-5,19.3-11.8,27-20.1,1-1.1,1.3-2.6,1-4h0c-.3-1.4-1.3-2.6-2.6-3.2L8.5.4c-1.4-.6-3.1-.5-4.4.4-1.3.9-2.1,2.4-2,3.9l1.1,30.9Z',
                breakpoints: {
                    2800: {
                        perPage: 2.5,
                        perMove: 2,
                        gap: '32px',
                    },
                    1400: {
                        perPage: 1.5,
                        perMove: 1,
                        gap: '32px',
                    },
                    1200: {
                        perPage: 3,
                        perMove: 3,
                        gap: '32px',
                    },
                    1100: {
                        perPage: 2,
                        perMove: 2,
                        gap: '16px',
                    },
                    800: {
                        perPage: 2,
                        perMove: 2,
                        gap: '16px',
                    },
                    600: {
                        perPage: 1,
                        perMove: 1,
                        gap: '16px',
                    },
                }
            });

        } else {

            slider = new Splide(splideSlider, {
                type: 'loop',
                rewind: true,
                gap: '32px',
                perPage: splideSliderSlides,
                drag: 'free',
                snap: true,
                mediaQuery: 'max',
                autoplay: false,
                interval: 4000,
                speed: 2000,
                pauseOnHover: true,
                pagination: true,
                arrowPath: 'M3.1,35.6c0,1.6.9,3,2.3,3.8.7.4,1.5.6,2.3.6.7,0,1.4-.2,2.1-.5,10.2-5,19.3-11.8,27-20.1,1-1.1,1.3-2.6,1-4h0c-.3-1.4-1.3-2.6-2.6-3.2L8.5.4c-1.4-.6-3.1-.5-4.4.4-1.3.9-2.1,2.4-2,3.9l1.1,30.9Z',
                breakpoints: {
                    1100: {
                        perPage: 
                            splideSliderSlides === 4 ? 3 : 
                            splideSliderSlides === 3 ? 2 :
                            splideSliderSlides === 2 ? 2 : 1,
                        gap: '16px',
                    },
                    800: {
                        perPage: 
                            splideSliderSlides === 4 ? 2 : 
                            splideSliderSlides === 3 ? 2 :
                            splideSliderSlides === 2 ? 1 : 1,
                        gap: '16px',
                    },
                    600: {
                        perPage: 
                            splideSliderSlides === 4 ? 1 : 
                            splideSliderSlides === 3 ? 1 :
                            splideSliderSlides === 2 ? 1 : 1,
                        gap: '16px',
                    },
                }
            });
            
        }

        slider.mount();

    });

});